import React from "react";

export function DesktopMoneyIllustration({
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M53 75V67.8571L60.1429 75M53 75V99.8571L60.3096 92.7912L67.0775 108.913L72.3466 106.701L65.8753 91.2857H76.4286L60.1429 75M53 75H26C24.8954 75 24 74.1046 24 73V21C24 19.8954 24.8954 19 26 19H102C103.105 19 104 19.8954 104 21V73C104 74.1046 103.105 75 102 75H60.1429"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="29" cy="24" r="1" fill="currentColor" />
      <circle cx="33" cy="24" r="1" fill="currentColor" />
      <circle cx="37" cy="24" r="1" fill="currentColor" />
      <path
        d="M74 39.3644C71.8502 36.131 68.1739 34 64 34C57.3726 34 52 39.3726 52 46C52 52.6274 57.3726 58 64 58C68.1739 58 71.8502 55.869 74 52.6356M47 44H62M47 48H62"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
